export default "__VITE_ASSET__B3mqR32n__"